import styled from 'styled-components';

export default styled.ul`
  padding: 0;
  list-style: none;
`;
